import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { RepairTaskDetailDto } from '@artemis-software/wr-api';
import { REPAIR_TASK_STATUS_COLORS } from '@components/repair-task-status-text/repair-task-status-text.component';
import StatusEnum = RepairTaskDetailDto.StatusEnum;

const REPAIR_TASK_STATUS_ICONS: Record<StatusEnum, string> = {
  DRAFT: 'edit-outline',
  TODO: 'radio-button-on-outline',
  IN_PROGRESS: 'play-circle-outline',
  FINISHED: 'checkmark-outline',
  DECLINED: 'slash-outline',
};

@Component({
  standalone: false,
  selector: 'wr-repair-task-status-icon',
  templateUrl: './repair-task-status-icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RepairTaskStatusIconComponent {
  readonly status = input<StatusEnum | null | undefined>();

  readonly iconName = computed(() => {
    const status = this.status();
    return status ? REPAIR_TASK_STATUS_ICONS[status] : '';
  });

  readonly color = computed(() => {
    const status = this.status();
    return status ? REPAIR_TASK_STATUS_COLORS[status] : 'basic';
  });
}
